import { primaryBase, redBase, skyBase, yellowBase } from '../../../../styles/design-tokens';

/**
 * Returns the color associated with an initiative status
 *
 * @param {string | undefined} status - The status string
 * @returns {string} The color code corresponding to the status
 */
const getStatusColor = (status: string | undefined): string => {
  const statusValue = (status || 'unknown').toLowerCase();
  switch (statusValue) {
    case 'on_track':
    case 'on track':
      return primaryBase;
    case 'at_risk':
    case 'at risk':
      return yellowBase;
    case 'off_track':
    case 'off track':
      return redBase;
    default:
      return skyBase;
  }
};

/**
 * Returns the label associated with an initiative status
 *
 * @param {string | undefined} status - The status string
 * @returns {string} The label corresponding to the status
 */
const getStatusLabel = (status: string | undefined): string => {
  const statusValue = (status || 'unknown').toLowerCase();
  switch (statusValue) {
    case 'on_track':
    case 'on track':
      return 'On Track';
    case 'at_risk':
    case 'at risk':
      return 'At Risk';
    case 'off_track':
    case 'off track':
      return 'Off Track';
    default:
      return 'Unknown';
  }
};

/**
 * Returns the most recent count from a metric
 *
 * @param {Record<string, number | null>} metric - The metric to get the latest count from
 * @returns {number | null} The latest count
 */
const getLatestCount = (metric: Record<string, number | null> | undefined): number | null => {
  if (!metric) return null;
  const dates = Object.keys(metric).sort();
  if (dates.length === 0) return null;

  const latestDate = dates[dates.length - 1];
  return metric[latestDate];
};

export { getLatestCount, getStatusColor, getStatusLabel };
